var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{on:{"change":_vm.onChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.checkList),function(item){return _c('el-checkbox',{key:item.id,attrs:{"label":item.id,"disabled":item.disabled}},[_vm._v(_vm._s(item.name_cn))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }